// Numéro d'édition stable dérivé de l'id de l'event
export function editionNumber(seed: string): number {
  let h = 0;
  for (let i = 0; i < seed.length; i++) h = (h * 31 + seed.charCodeAt(i)) >>> 0;
  return (h % 247) + 1;
}
// Returns just the zero-padded number (e.g. "07"). Callers add the "N°" prefix.
export function editionRoman(n: number): string {
  return n.toString().padStart(2, '0');
}
